module.exports = __webpack_public_path__ + "img/QIQFFC.png";